module.exports = __webpack_public_path__ + "static/media/img02.2d543538.webp";